import type { IconData } from '@stacksjs/iconify-core'

export const ss4x3: IconData = {
  "body": "<path fill=\"#078930\" d=\"M0 336h640v144H0z\"/><path fill=\"#fff\" d=\"M0 144h640v192H0z\"/><path fill=\"#000001\" d=\"M0 0h640v144H0z\"/><path fill=\"#da121a\" d=\"M0 168h640v144H0z\"/><path fill=\"#0f47af\" d=\"m0 0l415.7 240L0 480z\"/><path fill=\"#fcdd09\" d=\"M200.7 194.8L61.7 240l139 45.1L114.9 167v146z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ss4x3
